// utils/pixel.ts — helpers del Meta Pixel que usa App.tsx
// App.tsx ya inicializa el pixel (fbq init + PageView) e inyecta fbevents.js.

type PixelData = Record<string, any>

/** Dispara un evento estándar del Meta Pixel (Lead, PageView, InitiateCheckout, etc.). */
export function trackPixel(event: string, params?: PixelData) {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('track', event, params)
  }
}

/** Dispara un evento personalizado (no estándar) del Meta Pixel. */
export function trackCustomPixel(event: string, params?: PixelData) {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;(window as any).fbq('trackCustom', event, params)
  }
}

/** Se llama cuando fbevents.js terminó de cargar. El script vacía la cola solo; no-op seguro. */
export function flushPixelQueue() {}
